var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QSelectMod',_vm._g(_vm._b({staticClass:"select-store",attrs:{"value":_vm.value_,"options":_vm.options,"popup-max-height":"36rem"}},'QSelectMod',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }